import { render, staticRenderFns } from "./addReason.vue?vue&type=template&id=6d42f6ee&scoped=true"
import script from "./addReason.vue?vue&type=script&lang=js"
export * from "./addReason.vue?vue&type=script&lang=js"
import style0 from "./addReason.vue?vue&type=style&index=0&id=6d42f6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42f6ee",
  null
  
)

export default component.exports